import React from 'react';

// Predefined prompts for each mode
const PROMPTS = {
  meeting_summary: "Generate a detailed summary of the meeting in the attached video recording, including discussion points and action items with owners",
  process_documentation: "Generate detailed process documentation suitable for reference or training based on the process illustrated in the attached video recording. Write the documentation so that a new user will be able to follow step by step and accomplish the task illustrated in the video",
  documentation_with_charts: "Analyze this video to create comprehensive process documentation with workflow diagrams for a knowledge base article. Follow these requirements exactly:\n\n1. CONTENT REQUIREMENTS:\n   - Provide a detailed step-by-step explanation of the process shown\n   - Be extremely verbose and thorough - include all relevant details, context, and nuances\n   - Structure as a complete knowledge base article with clear sections\n   - Include overview, detailed steps, tips, and troubleshooting where applicable\n\n2. MERMAID DIAGRAM REQUIREMENTS:\n   - Create workflow diagrams using valid Mermaid syntax where helpful\n   - CRITICAL: Use only simple alphanumeric text in node descriptions and labels\n   - CRITICAL: No special characters like quotes brackets colons semicolons or symbols in node text\n   - CRITICAL: Use underscores instead of spaces in node IDs and labels\n   - CRITICAL: Keep all text simple to avoid syntax errors\n   - Example format: Start_Process --> Complete_Task --> End_Process\n   - Use flowchart format: graph TD or graph LR\n\n3. OUTPUT STRUCTURE:\n   - Title and overview section\n   - Prerequisites section if applicable\n   - Detailed step-by-step process\n   - Mermaid workflow diagram(s) showing the process flow\n   - Tips and best practices\n   - Troubleshooting common issues\n\nEnsure all Mermaid diagrams use simple text without special characters to prevent parsing errors.",
  custom: "" // Empty for custom mode
};

const PromptSelector = ({ mode, onModeChange, prompt, onPromptChange, disabled }) => {
  // Handle mode change and update prompt
  const handleModeChange = (e) => {
    const newMode = e.target.value;
    onModeChange(newMode);
    onPromptChange(PROMPTS[newMode]);
  };

  return (
    <div className="mb-4">
      <div className="mb-3">
        <label htmlFor="mode-select" className="form-label">Select Mode:</label>
        <select 
          id="mode-select" 
          className="form-select" 
          value={mode} 
          onChange={handleModeChange}
          disabled={disabled}
        >
          <option value="meeting_summary">Meeting Summary</option>
          <option value="process_documentation">Process/Tool Documentation</option>
          <option value="documentation_with_charts">Process Tool Documentation with Charts</option>
          <option value="custom">Custom Prompt</option>
        </select>
      </div>
      
      <div className="mb-3">
        <label htmlFor="prompt-text" className="form-label">Prompt:</label>
        <textarea 
          id="prompt-text" 
          className="form-control" 
          rows="4" 
          value={prompt} 
          onChange={(e) => onPromptChange(e.target.value)}
          placeholder="Enter or edit the prompt..."
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default PromptSelector;